<!-- doughnut -->
<mat-card  appearance="outlined"  >
  <mat-card-title *ngIf="donutChartDto">{{donutChartDto.title}}</mat-card-title>
  <mat-card-subtitle *ngIf="donutChartDto">{{donutChartDto.subTitle}}</mat-card-subtitle>
  <mat-card-content>
    <canvas  #donutChart id="donutChart" >{{ chart }}</canvas>
  </mat-card-content>
</mat-card>
